import { apiPaths } from '../config/apiPaths';
import { postJson } from '../postClient';

export const getPhoneApi = (inputData, authHeaders) =>
  postJson(apiPaths.whatsappChannel, inputData, authHeaders, {
    defaultError: 'Failed to fetch phone numbers',
  });
